import {ServerApi} from "../../../api.js";
import JSX from "../../../helpers/react.js";
import {TrailersEditPage} from "./TrailersEditPage.js";
import {handleFetchError} from "../../../helpers/functions.js";


function onLoad(){

    $('.trailers-tab').on('click', loanTrailers)
}
async function loanTrailers(){
    if($("#trailer-content").children('.center')[0]) {

        try {
            const index = await ServerApi.anime.trailers.get(page_id!);
            $('#trailer-content').html(<TrailersEditPage trailers={index}/>)
        } catch (e) {
            handleFetchError(e);
        }
    }

}



document.addEventListener('oneditformload', onLoad);
